<template>
    <div class="uEditor">
        <div class="content">
            <!--<div class="ue_zj_box">-->
                <!--<div class="ue_zj_content">-->
                    <!--<div class="ue_zj_image">-->
                        <!--<img alt="+ obj.objectname +" preview="videoList" data-pswp-uid="1" src="http://innertest.img.capwhale.com/kmc/content/20190826/c88e9a2ea5e3466482f3134c6c04ad7a" lazy="loaded"/>-->
                        <!--<span class="ue_zj_label">图文</span>-->
                    <!--</div>-->
                    <!--<div class="ue_zj_summary">-->
                        <!--<div class="ue_zj_title">-->
                            <!--<span class="ue_zj_name">素材图</span>-->
                        <!--</div>-->
                        <!--<div class="ue_zj_price">-->
                            <!--￥0.00-->
                        <!--</div>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<span class="ue_zj_btn">删除</span>-->
            <!--</div>-->
            <vueUeditorWrap :config="config" v-model="detail" @ready="ready" :destroy="true"></vueUeditorWrap>
            <!-- <div class="ue_btn">
                <el-button @click="preview">预览</el-button>
                <el-button @click="openImageDialog">素材图片</el-button>
                <el-button @click="openVideoDialog">素材视频</el-button>
                <el-button @click="openShopDialog">内部链接</el-button>
            </div> -->
        </div>
        <el-dialog title="预览内容" :visible.sync="dialogFormVisible" width="375px">
            <div v-if="detail" v-html="detail" class="preview"></div>
            <div v-else class="noPreview">暂无内容</div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <shop ref="shop" @setShop="setShop"></shop>
        <images ref="images" @setImage="setImage"></images>
        <videos ref="videos" @setVideo="setVideo"></videos>
    </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Shop from 'base/uEditor/dataComponents/shop.vue'
import Images from 'base/uEditor/dataComponents/images.vue'
import Videos from 'base/uEditor/dataComponents/videos.vue'
import $ from 'jquery'
const _url = window.location.origin
export default {
    name: 'uEditor',
    data() {
        return {
            editor: null, // uEditor实例
            detail: '',
            dialogFormVisible: false,
            config: {
                autoHeightEnabled: false, // 编辑器不自动被内容撑高
                initialFrameHeight: 250, // 初始容器高度
                initialFrameWidth: 680, // 初始容器宽度
                autoFloatEnabled: false, // 工具栏悬浮
                initialContent: '', // 默认内容
                elementPathEnabled: false, // 元素路径
                // wordCount: false, // 字数统计
                // enableAutoSave: false, // 自动保存
                // autoSyncData: false, // 自动同步编辑器要提交的数据
                // enableContextMenu: false, // 右键菜单
                // pasteplain: false, // 是否默认为纯文本粘贴
                // catchRemoteImageEnable: false, // 远程图片抓取关闭
                // imagePopup: false, // 图片操作的浮层开关，默认打开
                // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                serverUrl: `${_url}/api/ue/uploadEditorImage`,
                configUrl: `${_url}/api/ue/getConfig`,
                UEDITOR_HOME_URL: '/UEditor/', // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                toolbars: [
                    [
                        'source', // 源代码
                        '|',
                        'undo', // 前进
                        'redo', // 后退
                        '|',
                        'fontfamily', // 字体
                        'fontsize', // 大小
                        'bold', // 加粗
                        'forecolor', // 字体颜色
                        'italic', // 斜体
                        'underline', // 下划线
                        '|',
                        'justifyleft', // 左对齐
                        'justifycenter', // 居中
                        'justifyright', // 右对齐
                        'lineheight', // 行间距
                        '|',
                        'insertunorderedlist', // 无序列表
                        'directionalityltr', // 从左向右输入
                        'directionalityrtl', // 从右向左输入
                        '|',
                        'simpleupload', // 图片
                        'link' // 链接
                    ]
                ],
                lineheight: ['1', '1.5', '1.75', '2', '3', '4', '5'] // 行高
            }
        }
    },
    props: ['disabled', 'index'],
    mounted() {
        // $('.uEditor').on('click', '.dell', function () {
        //     alert(1)
        // })
    },
    methods: {
        setImage(images) {
            let str = ''
            images.forEach(obj => {
                str += '<img class="ue_zj_mater_image" alt="' + obj.cateinnerid + '" preview="videoList" src="' + obj.coveratturl + '"/>'
            })
            this.insert(str)
        },
        setVideo(videos) {
            let str = ''
            videos.forEach(obj => {
                str += '<video src="' + obj.fileatturl + '"></video>'
            })
            this.insert(str)
        },
        setShop(shops) {
            let str = ''
            shops.forEach(obj => {
                let kmctypeText = ''
                switch (obj.kmctype) {
                case 1 :
                    kmctypeText = '图文'
                    break
                case 2 :
                    kmctypeText = '报告'
                    break
                case 3 :
                    kmctypeText = '直播'
                    break
                case 4 :
                    kmctypeText = '视频'
                    break
                case 5 :
                    kmctypeText = '专栏'
                    break
                }
                str += '<div class="ue_zj_box" data-type="' + obj.kmctype + '" data-id="' + obj.objectid + '">' +
                    '<div class="ue_zj_content">' +
                    '<div class="ue_zj_image">' +
                    '<img alt="' + obj.objectname + '" preview="videoList" src="' + obj.furl + '"/>' +
                    '<span class="ue_zj_label">' + kmctypeText + '</span>' +
                    '</div>' +
                    '<div class="ue_zj_summary">' +
                    '<div class="ue_zj_title">' +
                    '<span class="ue_zj_name">' + obj.objectname + '</span>' +
                    '</div>' +
                    '<div class="ue_zj_price">' + obj.saleprice + '</div>' +
                    '</div>' +
                    '</div>' +
                    '<span class="ue_zj_btn"></span>' +
                    '</div>'
            })
            this.insert(str)
        },
        openVideoDialog() {
            this.$refs.videos.openDialog()
        },
        openImageDialog() {
            this.$refs.images.openDialog()
        },
        openShopDialog() {
            this.$refs.shop.openDialog()
        },
        insert(str) {
            this.editor.focus()
            this.editor.execCommand('inserthtml', str)
        },
        ready (editorInstance) {
            this.editor = editorInstance
            // console.log(`编辑器实例${editorInstance.key}: `, editorInstance)
            $(this.editor.body).on('click', '.ue_zj_btn', function () {
                $(this).parent().remove()
            })
            if (this.disabled) {
                this.editor.setDisabled()
            }
        },
        init(content) {
            this.detail = content
        },
        preview() {
            this.dialogFormVisible = true
        }
    },
    filters: {},
    watch: {
        detail() {
            // console.log(this.editor.getContent())
            if (this.index) {
                this.$emit('getUEditorContent', this.index,  this.detail)
            } else {
                this.$emit('getUEditorContent', this.detail)
            }
        }
    },
    computed: {},
    components: {
        VueUeditorWrap,
        Shop,
        Images,
        Videos
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .uEditor {
        .editor.options.elementPathEnabled{
            display: none !important;
        }
        .ue_zj_box{
            line-height: 1;
            width: calc(100% - 20px);
            padding: 10px;
            background: #F5F5F5;
            position: relative;
            .ue_zj_content{
                display: flex;
                .ue_zj_image{
                    margin-right: 10px;
                    position: relative;
                    width: 82px;
                    height: 60px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .ue_zj_label{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        display: inline-block;
                        padding: 3px 6px;
                        color: #fff;
                        font-size: 12px;
                        background: #909399;
                    }
                }
                .ue_zj_summary{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .ue_zj_title{
                        .ue_zj_name{
                            font-size: 14px;
                            color: #303133;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap
                        }
                    }
                    .ue_zj_price{
                        color: #F56C6C;
                    }
                }
            }
            .ue_zj_btn{
                position: absolute;
                top: calc(50% - 10px);
                right: 0;
                margin: 0 10px;
                width: 20px;
                height: 20px;
                display: none;
                /*background: url(./default/images/zj_icon/del.png);*/
                background-repeat: no-repeat;
                background-position: center;
            }
        }
        .ue_zj_box{
            &:hover{
                .ue_zj_btn{
                    display: block;
                }
            }
        }
        .ue_btn{
            margin-left: 8px;
            .el-button{
                display: block;
                margin: 0;
                width: 154px;
                height: 54px;
                border-radius: 0;
                border-width: 0;
                border: 1px solid #DDDDDD;
            }
            .el-button~.el-button{
                border-top: 0px solid #DDDDDD;
            }
        }
        .content{
            display: flex;
        }
        .edui-default .edui-editor,
        .edui-default .edui-editor-iframeholder {
            width: 750px !important;
            height: 375px;
        }
        .edui-default .edui-editor-iframeholder {
            height: 82% !important;
        }
        .edui-default .edui-editor{
            box-sizing: border-box;
        }
        .el-dialog{
            min-height: 500px;
            line-height: 1 !important;
            img{
                max-width: 100% !important;
            }
            .preview{
                min-height: 500px;
            }
            .noPreview{
                height: 500px;
                text-align: center;
                line-height: 500px;
                color: #ccc;
            }
        }
        .view{
            .zxr{
                width: 100px;
                height: 100px;
            }
        }
    }
</style>
